const ROUTES = {
    SIGNIN: "SignIn",
    DASHBOARD: "Dashboard",
    IMPORTACIONESREPORTE: "importaciones_reportes",
    SIGNUP: "SignUp",
    LEADS: "Leads",
    IMPORTACIONES: "Importaciones",
    CATEGORIAS: "Categorias",
    MEMBERSHIPS: "Membresias",
    PQR: "PQR",
    PQR_DETAIL: "PQRDetail",
    OPTIONS:"options",
    CREDENCIALES_PORTALES: "CredencialesPortales",
    EXTERNAL_CREDENTIALS: "ExternalCredentials",
    PLANS: "Plans",
    PLANS_CREATE: "PlansCreate",
    PLANS_EDIT: "PlansEdit",
    LONJAS: "Lonjas",
    LONJAS_DETAIL: "LonjasDetail",
    AI_USAGE: "AiUsage",
    REPUTACION_INMUEBLES: "ReputacionInmuebles",
    PROPERTIES_BULK_DELETE: "InmueblesEliminacionMasiva",
    LOCALIDADES: "Localidades",
    ROLES: "Roles",
    PLATAFORMA_AUDITORIA: "PlataformaAuditoria",
    PLATAFORMA_ROLES: "PlataformaRoles",
    PLATAFORMA_NEGOCIOS: "PlataformaNegocios"
}

export default ROUTES
